<template>
  <div class='sectionhead'>
    <a :name='linkname'></a>&nbsp;<br/><br/>{{ text }}
  </div>
</template>

<script>
export default {
  props: ['text', 'linkname']
}
</script>

<style lang="less" scoped>

@import '../css/globals.less';

div.sectionhead {
  position: relative;
  left: 0;
  right: 0;
  padding: 0.6em;
  text-align: center;
  font-family: @serif-font;
  font-weight: 300;
  font-size: 28pt;
}
</style>


// WEBPACK FOOTER //
// src/components/SectionHead.vue